import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-denmark',
    templateUrl: './denmark.component.html',
    styleUrls: ['./denmark.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DenmarkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
